<template>
  <div class="publicGoods">

      <div class="descTitle">{{$t('other.a2798')}} </div>
      <div class="areas">
          <div :class="{'condition':true,'activeBtn':item.active}" v-for="(item,index) in areaOptions" :key='index' @click="handle(item)">
              <div class="imgbox"><img :src="item.img" /></div>
              <div :class="{'imglabel':true,}">{{item.label}}</div>
          </div>
      </div>
      <GoodList :publicList="publicList" :storeList='storeList'  :industrialbelt='industrialbelt' @refreshData="refreshData"></GoodList>
      <div class="Pager">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[20,30,50,100]" :page-size="dataParams.offset" layout="total, sizes, prev, pager, next, jumper" :total="count">
        </el-pagination>
      </div>
  </div>
</template>

<script>

import utils from '../../../utils/utils'
import GoodList from './components/goodsList'
import api from '../../../api/api'
export default {
  data() {
    return {
        areaOptions:[{
            label:this.$t('other.a3226'),
            value:'All',
            img:null,
            active:false
        },
        // {
        //     label:this.$t('chat.Thailand'),
        //     value:'TH',
        //     img:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/b6a4e442750c4c9083f85fd7cdc57b8e.png',
        //     active:false
        // },{
        //     label:this.$t('h5.DSX_index_my'),
        //     value:'MY',
        //     img:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/c17928f1c89d40b69d1495d4c66d37ca.png',
        //     active:false
        // },{
        //     label:this.$t('h5.DSX_index_ph'),
        //     value:'PH',
        //     img:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/ea25f75da9474b41823b36fba55a6204.png',
        //     active:false
        // },
        // {
        //     label:this.$t('h5.DSX_index_tw'),
        //     value:'TW',
        //     img:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/4d94d6e2109a4c57a6c7af33f5a4498b.png',
        //     active:false
        // },
        // {
        //     label:this.$t('chat.Indonesia'),
        //     value:'ID',
        //     img:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/5ab4e79ca4284631af6015c7a9d87e43.png',
        //     active:false
        // },{
        //     label:this.$t('h5.DSX_index_vn'),
        //     value:'VN',
        //     img:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/0a594a0890224d54945198d56231339c.png',
        //     active:false
        // },{
        //     label:this.$t('chat.Singapore'),
        //     value:'SG',
        //     img:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/8d17f0d28b2b48a68ee4d6e54ebe7c47.png',
        //     active:false
        // },
        // {
        //     label:this.$t('h5.DSX_index_bz'),
        //     value:'BZ',
        //     img:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/c71468db1f744cf585a0161dbb2cfda7.png',
        //     active:false
        // },
        {
            label:this.$t('other.a2335'),
            value:'CN',
            img:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/664e760fce604256a502794ffa85df71.jpg',
            active:false
        },
        {
            label:this.$t('other.a3337'),
            value:'0',
            img:'https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com/images/20250225134313.png',
            active:true
        },
    ],
        currentPage:1,
        dataParams:{
            categoryIds:[],
            agencyUserId:null,
            country:'0',
            name:null,
            offset:50,
            page:0,
            sortType:0,
            groupName:null,
            userId:null,
            industrialBeltId:null,
            proportion:null,
            storeName:null,
            clearInWarehouse:false,
            categoryName:'',
        },
        publicList:[],
        count:0,
        userId:JSON.parse(localStorage.getItem('userInfo')).userId,
        industrialbelt:[],
        storeList:[],
        MapStoreList:null
    }
  },
  components:{
      GoodList,
	}, 
  computed: {

    

  },
  watch: {
        
    },

  created() {
      this.dataParams.agencyUserId=this.userId
      this.getPublishStore()
      this.getCommunityData()
      this.getDebuilt('0')
  },
  mounted(){
  },
  methods: {
      getPublishStore(){
        this.MapStoreList=new Map()
        api
        .getPublishStoreId()
        .then(res => {
        if(res.code === 200 ){
            console.log('87412',res)
            this.storeList=res.data.map(p => {
                return {
                    label:p.storeName,
                    value:p.storeId,
                    country:p.storeAddress
                }
            })

            this.MapStoreList.set('All',this.storeList)
            

            this.storeList.forEach(p => {
                let list=this.MapStoreList.get(p.country)
                if(!list){
                    list=[]
                }
                list.push(p)
                this.MapStoreList.set(p.country,list)
            })

            console.log('MapStoreList',this.MapStoreList)
            

        }else{
            this.$message.warning(res.msg)
        }
        })
      },
      refreshData(item){
          console.log(item)
          this.dataParams.industrialBeltId=item.belitId
          this.dataParams.storeId=item.storeId
          this.dataParams.clearInWarehouse=item.clearInWarehouse
          this.dataParams.proportion=item.proportion
          this.dataParams.groupName=item.groupName
          this.dataParams.itemSku=item.itemSku
          this.dataParams.cusCode=item.cusCode
          this.dataParams.page=this.dataParams.page
          this.dataParams.categoryName=item.categoryName
          this.dataParams.freeDistribution=item.freeDistribution
          this.dataParams.multiLevelDistribution=item.multiLevelDistribution
          this.getCommunityData()
      },
      handle(item){
        console.log(item)
        this.areaOptions.forEach(p => {
            p.active=false
        })
        this.storeList=this.MapStoreList.get(item.value)
        item.active=true
        this.dataParams.page=0
        this.dataParams.country=item.value == 'All' ? null : item.value
        this.getCommunityData()
        this.getDebuilt(item.value)
        console.log('data',this.dataParams)
      },

      /*获取某地区下的产业带
        *参数：TW  userID
      */
      getDebuilt(id){
            api
            .getIndustialBelt({
            region:id == 'All' ? null : id,
            userId:this.userId
            })
            .then(res => {
            if(res.code === 200 ){
                console.log('852',res)
                this.industrialbelt=res.data
    
            }else{
                this.$message.warning(res.msg)
            }
            })
      },

      getCommunityData(){
        this.showLoading()
            api
            .getPublicStoreItem(this.dataParams)
            .then(res => {
                if(res.code == 200){
                let groupids=[]
                res.data.groups.forEach(p => {
                    p.checked=false
                    p.minGrossProfitRate = p.minGrossProfitRate < 0 ? 0 : p.minGrossProfitRate
                    groupids.push(p.groupId)
                })
                // this.getStoreItemPrice(groupids)
                this.publicList=res.data.groups
                this.count=res.data.count
                console.log('公共分销仓的产品',this.publicList)
                }else{
                this.$message.warning(res.msg)
                }
            })
        },

      //控制每页显示订单条数
	  handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.dataParams.offset =Number( `${val}`)
        this.handleCurrentChange()
      },
      //显示当前第几页
      handleCurrentChange(val) {
        let currentPage = (parseInt(`${val}`) - 1) * this.dataParams.offset
        this.dataParams.page=currentPage ? currentPage : 0
        this.getCommunityData(this.dataParams)
        
      },

    
  }
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

.publicGoods{
    background-color: $backgroup-color;
    margin-right: 10px;
    min-height: 100vh;
    padding-left: 10px;

    .Pager{
        position: fixed;
        bottom: 0;
        left: 205px;
        right: 0;
        height: 40px;
        line-height: 40px;
        background-color: #fff;
        text-align:right;
        
    }

    // .activeBtn{
    //     color: #FF4000;
    //     background-color: none!important;
    //     border-bottom: 3px solid #FF4000;
    // }
    .activeBtn{
        color: #fff;
        background-color: #409eff!important;
        // border-bottom: 3px solid #FF4000;
    }

    .descTitle{
        padding: 15px 10px 15px 10px;
    }

    .areas{
        @include flex-start();
        flex-wrap: wrap;
        background-color:#fff;
        height: 45px;
        line-height: 45px;
        margin-right: 6px;
        
        .condition{
            margin-right: 25px;
            font-weight: bold;
            font-size: 1rem;
            padding-right:15px;
            padding-left: 15px;
            border-radius: 10px;
            display: flex;
            cursor: pointer;

            .imgbox{
                width: 1rem;
                height: 1rem;
                margin-right: 10px;

                img{
                    width: 100%;
                }
            }

        }
        .condition:first-child{
            padding-left: 0px;
        }
        
    }
}



</style>